module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "NBA_G_League_Ignite_logo_(2022).f19f19bd.svg";